export class ValidateData{
    constructor(
        public code: string
    ){
        this.id = null;
    }
    public id: number;
    public name: string;
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/validate-data.ts